import {
  Button,
  Icon,
  StatusDot,
  StatusDotUse,
  Tooltip,
} from "@growtherapy/sprout-ui";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";

export function IncompatibleApplicationAdmitButton() {
  const text = "Application compatibility issue. All parties should refresh.";
  return (
    <Tooltip
      text={text}
      /**
       * Although this Tooltip wraps a ControlPanelButton, the tooltip only ever
       * shows when the ControlPanelButton is disabled. In order to make this
       * tooltip still accessible for all users, we wrap it in a <div/> so that
       * there is an element to add the tooltip props to and set
       * childIsInteractive={false} (since the ControlPanelButton won't be
       * actually interactive when the tooltip is enabled).
       */
      childIsInteractive={false}
    >
      <div className="relative">
        <Button disabled={true} aria-label={text}>
          <Icon
            icon={faExclamationTriangle}
            aria-hidden
            fontVariant="xs"
            className="mr-1"
          />
          Admit
        </Button>
        <StatusDot
          className="absolute -top-1 -right-1"
          use={StatusDotUse.Failure}
        />
      </div>
    </Tooltip>
  );
}
